import React from 'react'
import Friend from "../Friends/Friend/Friend";
import css from "../Friends/Friends.module.css";

const Followers = props => {
    return (

        <div className={css.friends__wrapper}>
            <h2 className={css.friends__title}>{props.followers.length} Followers</h2>
            <div className={css.friends}>
            {props.followers.map(item => <Friend uid={item.uid} name={item.name} photoURL={item.photoURL}
                                                 backgroundPhotoUrl={item.backgroundPhotoUrl}/>)}
            </div>
        </div>

    )
}

export default Followers